import * as React from 'react';
import Checkbox from 'material-ui/Checkbox';
import { FormControlLabel } from 'material-ui/Form';

// Component
export interface IProps {
    checked: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
    value?: string;
    label: string;
    disabled?: boolean;
}
function LabelCheckbox(props: IProps) {
    return (
        <FormControlLabel
            control={
                <Checkbox
                    checked={props.checked}
                    onChange={props.onChange}
                    value={props.value}
                />
            }
            label={props.label}
            disabled={props.disabled}
        />
    );
}

export default LabelCheckbox;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Checkbox/LabelCheckbox.tsx